import { Fragment } from 'react';
import { translate } from 'react-switch-lang';
import { Card, CardBody } from 'reactstrap';
import Breadcrumb from 'src/pages/accueil/breadcrumb';
const ProjectWrapper = (props) => {
  return (
    <Fragment>
      <Breadcrumb parent={props.t('list_projects')} url={'project/list'} title={props.t(props.title)} />
      <Card>
        <CardBody>
          {props.spinner === true ? (
            <div className="loader-box">
              <div className="loader-3"></div>
            </div>
          ) : (
            props.children
          )}
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default translate(ProjectWrapper);
